import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { getExternalWagerSchema } from './externalPlayerWager.js';

export const externalWagerResponseSchema = z
  .object({
    ownWager: getExternalWagerSchema,
  })
  .transform(({ ownWager }) => ({ data: ownWager }));

export const externalWagerApiResponse = {
  parse: (data: unknown) => z.union([externalWagerResponseSchema, apiErrorSchema]).parse(data),
} as const;
